/* unplugin-vue-components disabled */import script from "./SureKeyWordFiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./SureKeyWordFiles.vue?vue&type=script&lang=ts&setup=true"

import "./SureKeyWordFiles.vue?vue&type=style&index=0&id=aa7e17b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa7e17b8"]])

export default __exports__